import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonComponent } from '../../../components/button/button.component';

@Component({
    selector: 'app-already-paid',
    imports: [
        CommonModule,
        ButtonComponent,
    ],
    templateUrl: './already-paid.component.html',
    styleUrl: './already-paid.component.scss'
})
export class AlreadyPaidComponent {

}
